import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function AppRedirect() {
  const location = useLocation();

  function detectDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log("User Agent:", userAgent); // Add this to check the actual user agent in the console

    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    return "Other";
  }

  useEffect(() => {
    const deviceType = detectDevice();
    console.log("Device Type:", deviceType); // This will confirm what device type is being detected

    if (location.pathname === '/app') {
      switch (deviceType) {
        case 'iOS':
          window.location.href = 'https://apps.apple.com/us/app/vote-vocal/id6499540241';
          break;
        case 'Android':
          window.location.href = 'https://play.google.com/store/apps/details?id=com.votevocal.info.vv';
          break;
        default:
          window.location.href = 'https://apps.apple.com/us/app/vote-vocal/id6499540241';
          break;
      }
    }
  }, [location]);

  return null; // Ensure nothing is rendered by this component
}

export default AppRedirect;